<template>
  <div class="unsubscribe">
    <Breadcrumbs :items="breadcrumbs"/>

      <p>To delete your RayPRO account and personal data, please confirm below.</p>

      <rp-button @click='activeConfirm = !activeConfirm' class="confirm-btn">Delete account</rp-button>

    <rp-overlay :active="activeConfirm">
      <rp-confirm
        icon="warning"
        messageText='This action can not be reverted. Are you sure'
        :cancel="closeModal"
        :confirm="submit"/>
    </rp-overlay>
    <rp-overlay :active="activeAlert">
      <rp-alert
        icon="done"
        :message="successMessage"
        :onClick="successFunction" />
    </rp-overlay>
  </div>
</template>

<script>
import {deletePatientOwn} from 'raypro_ui/src/api/users'

import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Confirm from 'raypro_ui/src/components/ui/DeleteConfirm'
import Alert from 'raypro_ui/src/components/ui/Alert'
import Button from 'raypro_ui/src/components/ui/inputs/Button'

import page from '@/mixins/page'
import Breadcrumbs from '@/components/Breadcrumbs'
import {mapActions, mapGetters} from 'vuex'

export default {
  components: {
    'rp-overlay': Overlay,
    'rp-confirm': Confirm,
    'rp-button': Button,
    'rp-alert': Alert,
    Breadcrumbs
  },

  data() {
    return {
      activeConfirm: false,
      activeAlert: false,
      successMessage: 'Success! Account has been deleted.',
      breadcrumbs: [
        {label: 'Delete'},
        {label: 'Delete own account'}
      ]
    }
  },

  mixins: [page],

  computed: {...mapGetters(['getAuthToken'])},

  methods: {
    ...mapActions(['logoutUser']),

    deleteOwnAccount() {
      deletePatientOwn({userId: this.$store.getters.authUser.id})
        .then(() => {
          this.activeConfirm = false
          this.activeAlert = true
        })
        .catch(({response}) => {
          this.errors = response
        })
    },
    successFunction() {
      this.logoutUser(this.getAuthToken)
        .then(() => {
          this.$router.push({name: 'Login'})
        })
        .catch(({response}) => {
          this.errors = response
        })
    },

    closeModal() {
      this.activeConfirm = false
    },

    submit() {
      this.deleteOwnAccount()
    }
  }
}
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'

.confirm-btn
  color: $color-error
  border-color: $color-error
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/DeleteAccount.vue